import React, { useEffect, useState } from 'react';
import './App.css';
import AppViewer from './components/AppViewer';
import axios from 'axios';
import { socket } from './socket';
import services from './services';
import { PrivilegesViewChecker } from './utils/PrivilegesChecker';
import { getLocalStorageItem, setLocalStorageItem } from './utils/Localstorage/localStorageUtils';

function App({parentOrigin}) {
    const [userRole, setUserRole] = useState();

    useEffect(() => {
        checkEmailUser();
        getUserRole();
    }, []);

    const checkEmailUser = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/token/`, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });
            const findUnAuth = response?.data?.data?.find(({ token_status }) => token_status === 'token is authorized');
            if (findUnAuth?.client_id) {
                updateAuthEmail(findUnAuth.client_id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const updateAuthEmail = async (client_id) => {
        try {
            await services.email.updateAuthEmail(client_id);
        } catch (error) {
            console.error(error);
        }
    };
    const userDataRaw = getLocalStorageItem('userData');
    let userData;
    if (typeof userDataRaw === 'string') {
        try {
            userData = JSON.parse(userDataRaw);
        } catch {
            userData = null;
        }
    } else {
        userData = userDataRaw;
    }
    const getUserRole = async () => {
        try {
            const uid = userData?.user?._id;
            if (!uid) return console.warn('User ID missing in localStorage');

            const response = await services.user.GET_USER_ID(uid);
            setLocalStorageItem('userData', response?.data?.data);
            setUserRole(response?.data?.data?.role);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        socket.on('messageSaved', () => { });
        return () => {
            socket.off('messageSaved');
        };
    }, []);

    const showWhatsappTab = PrivilegesViewChecker("whatsapp");
    const showGmailTab = PrivilegesViewChecker("gmail");

    return (
        <div className="app">
            <AppViewer showGmailTab={showGmailTab} showWhatsappTab={showWhatsappTab} userRole={userRole} />
        </div>
    );
}

export default App;
